import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import format from 'date-fns/format';
import { CustomCard } from '../Card/Card';
import { DSButton } from '../Button/Button';

import { StyledProjectCard } from '../../styles/templates/Projects';
import { DSTheme } from '../../styles/themes/types';
import { ApplicationInterface } from '../../interfaces/application';

type DeviceCardProps = {
  device: ApplicationInterface;
  onRegenerateSecret: (device: ApplicationInterface) => void;
};

const useStyles = makeStyles((theme: DSTheme) => ({
  namespace: {
    marginTop: '8px',
    color: theme.palette.grey[600],
  },
  date: {
    marginTop: '32px',
    color: theme.palette.grey[600],
  },
}));

const DeviceCard: React.FC<DeviceCardProps> = ({ device, onRegenerateSecret }) => {
  const classes = useStyles();
  const formattedDate = format(new Date(device.lastUpdated as string), 'dd MMMM yyyy, HH:mm');

  return (
    <CustomCard thin>
      <StyledProjectCard>
        <div>
          <Typography variant="subtitle1">{device.info.applicationId}</Typography>
          <Typography className={classes.namespace}>Namespace: {device.setup.namespace}</Typography>
        </div>

        <div>
          <DSButton onClick={() => onRegenerateSecret(device)} className=" wide">
            Regenerate Secret
          </DSButton>
          <Typography className={classes.date}>{formattedDate}</Typography>
        </div>
      </StyledProjectCard>
    </CustomCard>
  );
};

export default DeviceCard;
